import { useEffect, useState } from "react"
import { getStoryblokApi } from "@storyblok/react"
import { Link } from "react-router-dom"

export default function BlogRoute() {
  const [posts, setPosts] = useState<any[]>([])

  useEffect(() => {
    const fetchPosts = async () => {
      const sbApi = getStoryblokApi()
      const { data } = await sbApi.get("cdn/stories", {
        starts_with: "blog/",
        version: "published",
        is_startpage: false,
        per_page: 100,
      })
      setPosts(data.stories)
    }

    fetchPosts()
  }, [])

  if (!posts.length) return <div></div>

  const featuredPost = posts.find((post) => post.content.isFeatured)
  const otherPosts = posts.filter((post) => !post.content.isFeatured)

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 space-y-16">
      {featuredPost && (
        <Link
          to={`/blog/${featuredPost.slug}`}
          className="block group relative overflow-hidden rounded-[10px] shadow-[0_10px_25px_rgba(0,0,0,0.06)] transition-transform hover:-translate-y-1"
        >
          <div className="relative h-[480px] overflow-hidden">
            ...
            <img
              src={featuredPost.content.featureImage.filename}
              alt={featuredPost.content.featureImage.alt || "Featured blog"}
              className="absolute inset-0 w-full h-full object-cover brightness-90 group-hover:brightness-100 transition"
            />
            <div className="absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm"></div>
            <div className="relative z-10 h-full flex flex-col justify-end p-10">
              <h2 className="text-white text-4xl md:text-5xl font-extrabold mb-4 drop-shadow-lg">
                {featuredPost.content.title.content[0].content[0].text}
              </h2>
              <p className="text-white text-lg mb-4 max-w-2xl drop-shadow-md">
                {featuredPost.content.previewText}
              </p>
              <span className="text-blurple bg-white px-4 py-2 rounded-full text-sm font-semibold self-start shadow-md">
                Read More →
              </span>
            </div>
          </div>
        </Link>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {otherPosts.map((post) => (
          <Link key={post.id} to={`/blog/${post.slug}`}>
            <div className="group bg-white rounded-[10px] shadow-xl overflow-hidden transition-transform hover:-translate-y-1 hover:shadow-2xl flex flex-col h-full">
              <div className="relative h-52 overflow-hidden">
                <img
                  src={post.content.featureImage.filename}
                  alt={post.content.featureImage.alt}
                  className="absolute inset-0 w-full h-full object-cover transition-transform group-hover:scale-105"
                />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blurple transition">
                  {post.content.title.content[0].content[0].text}
                </h3>
                <p className="text-sm text-gray-600 line-clamp-3 flex-grow">
                  {post.content.previewText}
                </p>
                <span className="mt-4 text-blurple font-medium text-sm">
                  Read More →
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
